import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '../../../shared/services/environment.service';
import { catchError, Observable, take } from 'rxjs';
import { IAllAirlinesResponse } from '../models/airlines.models';
import { IAirlineInfoResponse } from '../models/airlineInfo.models';

@Injectable({
  providedIn: 'root',
})
export class PopularAirlinesApiService {
  public http = inject(HttpClient);
  public env = inject(EnvironmentService);

  constructor() {}

  getAllAirlinesApi(): Observable<IAllAirlinesResponse> {
    // let api = `${this.env.users}/api/user/getUser`
    let api = `https://cms.travasky.com/api/GetAllAirLines`;
    return this.http.get<IAllAirlinesResponse>(api).pipe(
      take(1),
      catchError((err) => {
        throw err;
      }),
    );
  }

  getAirlineInfoApi(iatacode: string): Observable<IAirlineInfoResponse> {
    // let api = `${this.env.users}/api/user/getUser`
    let api = `https://cms.travasky.com/api/GetAirLineInfo?code=${iatacode}`;
    return this.http.get<IAirlineInfoResponse>(api).pipe(
      take(1),
      catchError((err) => {
        throw err;
      }),
    );
  }
}
